import { CurrencyAmount, Token } from '@kodiak-finance/sdk-core'
import { ButtonPrimary } from 'components/Button'
import Column from 'components/Column'
import CurrencyInputPanel, { BalanceFlex } from 'components/CurrencyInputPanel'
import { useStepLineStateUpdate } from 'components/StepLine/context/StepLineContext'
import { XKDK_ADDRESSES } from 'constants/addresses'
import { useToken } from 'hooks/Tokens'
import { useConnection } from 'hooks/useConnection'
import { useDividends } from 'hooks/useStaking'
import tryParseCurrencyAmount from 'lib/utils/tryParseCurrencyAmount'
import { useMemo, useState } from 'react'
import { formatCurrencyAmount } from 'utils/formatCurrencyAmount'

import { ReactComponent as Wallet } from '../../assets/svg/icons/Wallet.svg'
export type DeallocationStepState = {
  amount: CurrencyAmount<Token> | undefined
}
const DeallocateViewStep = ({ next }: { next: () => void }) => {
  const [inputKdk, setInputKdk] = useState('')
  const { chainId } = useConnection()
  const xKdkAddress = XKDK_ADDRESSES[chainId]
  const xKdkToken = useToken(xKdkAddress)
  const { userUsageAllocation } = useDividends()

  const update = useStepLineStateUpdate<DeallocationStepState>()

  const amount = useMemo(() => {
    const amount = tryParseCurrencyAmount(inputKdk, xKdkToken || undefined)
    update({ amount })
    return amount
  }, [inputKdk, xKdkToken])
  const isInsufficientBalance = Boolean(amount && userUsageAllocation && amount.greaterThan(userUsageAllocation))
  const isActionDisabled = !amount || !amount.greaterThan('0') || !userUsageAllocation || isInsufficientBalance
  const actionLabel = isInsufficientBalance ? 'Insufficient xKDK' : 'Unstake'

  return (
    <Column width="100%" gap="8px">
      <CurrencyInputPanel
        // hideBalance={true}
        value={inputKdk}
        onUserInput={setInputKdk}
        onMax={() => setInputKdk(userUsageAllocation?.toExact() ?? '0')}
        showMaxButton={true}
        currency={xKdkToken}
        renderBalance={() => (
          <BalanceFlex>
            <Wallet height={18} width={18} />
            <>{formatCurrencyAmount(userUsageAllocation, 4)}</>
          </BalanceFlex>
        )}
        label="kdk"
        id="convert-kdk"
      />
      <ButtonPrimary disabled={isActionDisabled} onClick={next}>
        {actionLabel}
      </ButtonPrimary>
    </Column>
  )
}

export default DeallocateViewStep
